export default "__VITE_ASSET__d684607b__"